<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">
		<c-card >
			<h3 slot="title" color="green"> {{ $t("pages.orderForm.companyDetails") }}</h3>
			<cols-row md="4">
				<branches-select name="branch_id" :clearable="false" required :disable="disabledProject"
					v-if="form.client_id" lazy="client_id" :filters="{client_id: form.client_id}"
					v-model="form.branch_id"/>
				<smart-input disabled :error="inputErrors.name" :label="$t('pages.projectForm.projectName')" :value="form.name"></smart-input>
			</cols-row>
		</c-card>
		<c-card>
			<h3 slot="title" color="green">{{ $t("pages.orderConsForm.projDetails") }}</h3>
			<cols-row md="6">
				<smart-input :error="inputErrors.client_name" :label="$t('attributes.customerName')" v-model="form.client_name"></smart-input>
				<smart-input disabled class="font-weight-bold" :error="inputErrors.contractor" :label="$t('pages.projectForm.contractor')" :value="form.contractor"></smart-input>
			</cols-row>
			<cols-row md="6">
				<cites-select v-model="form.city" />
				<smart-input :error="inputErrors.contact" :label="$t('pages.projectForm.contact')" v-model="form.contact"></smart-input>
				<smart-input :error="inputErrors.address" :label="$t('pages.projectForm.address')" v-model="form.address"></smart-input>
				<smart-input :error="inputErrors.contact_tel" :label="$t('pages.orderTable.tel') + ' ' +$t('pages.projectForm.contact')" v-model="form.contact_tel"></smart-input>
			</cols-row>
      <cols-row md="6">
				<smart-input :error="inputErrors.contact2" :label="$t('pages.orderConsForm.secondContact')" v-model="form.contact2"></smart-input>
				<smart-input :error="inputErrors.contact2_tel" :label="$t('pages.orderTable.tel') + ' ' +$t('pages.projectForm.contact')" v-model="form.contact2_tel"></smart-input>
			</cols-row>
      <cols-row md="6">
				<smart-input :error="inputErrors.contact3" :label="$t('pages.orderConsForm.thirdContact')" v-model="form.contact3"></smart-input>
				<smart-input :error="inputErrors.contact3_tel" :label="$t('pages.orderTable.tel') + ' ' +$t('pages.projectForm.contact')" v-model="form.contact3_tel"></smart-input>
			</cols-row>
			<v-card-actions>
				<v-btn type="submit" color="success">{{$t('attributes.save')}}</v-btn>
			</v-card-actions>
		</c-card>
	</form>
</template>


<script>
	import ProjectModule from "src/store/modules/Project.module";
	import FormView from "src/mixins/FormView";
	import CitesSelect from "dev/view/measurements/CitesSelect";
	import BranchesSelect from "dev/view/branches/BranchesSelect";
	import CCard from "dev/scaffoldings/cCard";

	export default {
		props: {project:Object},
		name: "project-form",
		components: {CitesSelect,BranchesSelect,CCard},
		data() {
			return {
				form: {
					name: null,
				},
			};
		},
		mixins: [new FormView(ProjectModule,"project")],
		computed: {
			isNew(){
				return !!this.project.id;
			}
		}
	};
</script>

<style>

</style>
